import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Grid2 } from "@mui/material";
import axios from "axios";
import { XMLParser } from "fast-xml-parser";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

let regions = ["ne", "cat", "phx"];
let series = [];

function ImageServiceTesting(mode) {
	const [focusRegion, setFocusRegion] = React.useState("ne");
	//from the dropdown
	const [focusSeries, setFocusSeries] = React.useState();
	//all ther series api
	const [seriesAPI, setSeriesAPI] = React.useState([]);

	const [seriesGrades, setSeriesGrade] = React.useState([]);
	const [prefGrade, setPrefGrade] = React.useState([]);
	const [focusGrade, setFocusGrade] = React.useState([]);
	const [focusSeriesAPI, setFocusSeriesAPI] = React.useState([]);
	const [fullSeriesGradeAndColors, setFullSeriesGradeAndColors] =
		React.useState([]);

	React.useEffect(() => {
		//for the nav
		loadSeriesAPI();
	}, []);
	// React.useEffect(() => {
	// 	console.log("regionJSON updated");
	// 	console.log(regionJSON);
	// 	if (focusSeries) {
	// 		console.log("running offer data");
	// 		buildGradeData();
	// 	}
	// }, [regionJSON]);

	React.useEffect(() => {
		console.log("----- ", focusSeries);
		for (var i = 0; i < seriesAPI.length; i++) {
			if (seriesAPI[i].seriesname == focusSeries) {
				console.log(seriesAPI[i]);
				setFocusSeriesAPI(seriesAPI[i]);
				loadSeriesInfoFile(seriesAPI[i]);
				console.log(focusSeriesAPI);
			}
		}
	}, [focusSeries]);

	React.useEffect(() => {
		if (focusGrade.length > 0) {
			console.log("----- ", focusGrade);
			//get all colors form the
			console.log(fullSeriesGradeAndColors[focusGrade].colors);
			//build images with all the info
			var htmlDiv = document.getElementById("imageHolder");
			htmlDiv = "";
			var images = "";
			let angles = ["1", "2", "3", "4"];
			let sizes = ["320", "500", "640", "1200", "image"];
			// loop though all the colors
			for (
				var i = 0;
				i < fullSeriesGradeAndColors[focusGrade].colors.length;
				i++
			) {
				for (var j = 0; j < angles.length; j++) {
					for (var s = 0; s < sizes.length; s++) {
						var color = fullSeriesGradeAndColors[focusGrade].colors[i];
						//build the image
						images += `<div class='imageContainer' >
								<a style='display:flex;flex-direction:column;color:white;padding:10px' href="https://cdn.flashtalking.com/feeds/tcaa/ad_services/secured/imageservice/3/${focusSeriesAPI.ToyotaAPIName}/${focusSeriesAPI.modelyear}/${focusGrade}/${color}/${angles[j]}/${sizes[s]}.webp" target="_blank">
							`;
						let theSizeName = sizes[s];
						if (theSizeName == "image") {
							theSizeName = "full";
						}
						images += `<span>${focusSeriesAPI.modelyear} color: ${color} angle: ${angles[j]} size: ${theSizeName}</span>`;
						images += `<img class="theSeries" src="https://cdn.flashtalking.com/feeds/tcaa/ad_services/secured/imageservice/3/${focusSeriesAPI.ToyotaAPIName}/${focusSeriesAPI.modelyear}/${focusGrade}/${color}/${angles[j]}/${sizes[s]}.webp"/>`;
						images += "</div>";
					}
				}
			}
			document.getElementById("imageHolder").innerHTML = images;
		}
	}, [focusGrade]);
	async function buildGradeData(json) {
		console.log("buildGradeData");
		console.log(json);
		//list all grade levels
		var grades = Object.keys(json);
		console.log(grades);
		setSeriesGrade(grades);

		//get all the json inside this grade

		// le
		// :
		// {colors: Array(7), colors_included: Array(6)}
		// se
		// :
		// {colors: Array(7), colors_included: Array(5)}
		// xle
		// :
		// {colors: Array(7), colors_included: Array(4)}
		// xse
		// :
		// colors
		// :
		// (11) ['218', '795', '1l5', '8q4', '3u5', '089', '1l7', '2yj', 'm04', '2ps', '2sc']
		// colors_included
		// :
		// (4) ['218', '795', '8q4', '1l7']
		// gradePreferred
		// :
		// true
		//get the grade that has the preferred tag
		for (var i = 0; i < grades.length; i++) {
			if (json[grades[i]].gradePreferred) {
				console.log("preferred grade is: " + grades[i]);
				setPrefGrade(grades[i]);
				// setSeriesGrade;
			}
		}
	}
	function datacombine(data, label) {
		var html = "";
		if (data) {
			// if data is an array
			if (Array.isArray(data)) {
				for (var i = 0; i < data.length; i++) {
					html += `<span><b>${label}:</b> ${data[i]}</span>`;
				}
			} else {
				html = `<span><b>${label}:</b> ${data}</span>`;
			}
		} else {
			if (label != "Title") {
				html = `<span class="fbdataerror"><b>${label}:</b> ${data} is missing</span>`;
			} else {
				html = `<span><b>${label}:</b> ${data} is empty but its ok</span>`;
			}
		}
		return html;
	}
	async function loadSeriesAPI() {
		const response = await fetch(
			"https://cdn.flashtalking.com/feeds/tcaa/ad_services/secured/seriesapi/full/ne/seriesapi.json"
		);
		const data = await response.json();

		setSeriesAPI(data);
		//loop through the serieapi data nd find the macth with the focusSeries

		console.log(focusSeriesAPI);
	}
	async function loadSeriesInfoFile(focusSeriesAPI) {
		var xml = "";

		await getLiveXML(focusSeriesAPI);
	}

	async function getLiveXML(focusSeriesAPI) {
		console.log("getLiveXML");

		//fetch xml files at https://xmlconverter.datcdn.com/phx_facebook_nf_2.xml
		console.log(seriesAPI);
		axios
			.get(
				`https://cdn.flashtalking.com/feeds/tcaa/ad_services/secured/imageservice/3/${focusSeriesAPI.ToyotaAPIName}/${focusSeriesAPI.modelyear}/info.json`
			)
			.then((response) => {
				// console.log(response.data);

				const json = response.data;
				// console.log(json);
				setFullSeriesGradeAndColors(json);
				buildGradeData(json);
			})
			.catch((error) => {
				console.error("There was an error!", error);
			});
	}

	return (
		<div id="htmlPage">
			<h1>ImageServiceTesting</h1>
			<Grid2 container spacing={2} direction="column">
				{/* <FormControl sx={{ m: 1, width: 300 }}>
					<InputLabel id="region-select-label">Region</InputLabel>
					<Select
						labelId="region-select-label"
						id="region-select"
						value={focusRegion ? focusRegion : ""}
						onChange={(e) => setFocusRegion(e.target.value)}
						input={<OutlinedInput label="Region" />}
						MenuProps={MenuProps}
					>
						{regions.map((region) => (
							<MenuItem key={region} value={region}>
								<ListItemText primary={region} />
							</MenuItem>
						))}
					</Select>
				</FormControl> */}
				<FormControl sx={{ m: 1, width: 300 }}>
					<InputLabel id="series-select-label">Series</InputLabel>
					<Select
						labelId="series-select-label"
						id="series-select"
						value={focusSeries ? focusSeries : ""}
						onChange={(e) => setFocusSeries(e.target.value)}
						input={<OutlinedInput label="Series" />}
						MenuProps={MenuProps}
					>
						{seriesAPI.map((series) => (
							<MenuItem key={series.seriesname} value={series.seriesname}>
								<ListItemText primary={series.seriesname} />
							</MenuItem>
						))}
					</Select>
				</FormControl>
				{seriesGrades.length > 0 && (
					<FormControl sx={{ m: 1, width: 300 }}>
						<InputLabel id="grade-select-label">Grade</InputLabel>
						<Select
							labelId="grade-select-label"
							id="grade-select"
							value={focusGrade ? focusGrade : ""}
							onChange={(e) => setFocusGrade(e.target.value)}
							input={<OutlinedInput label="Grade" />}
							MenuProps={MenuProps}
						>
							{seriesGrades.map((grade) => (
								<MenuItem key={grade} value={grade}>
									{console.log("prefGrade:", prefGrade)}
									{console.log("grade building:", grade)}
									{prefGrade == grade ? (
										<ListItemText
											primary={grade + " (preferred)"}
											style={{ color: "limegreen" }}
										/>
									) : (
										<ListItemText primary={grade} />
									)}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				)}
			</Grid2>
			<Grid2 container spacing={2} id="ads">
				<div
					id="imageHolder"
					style={{ display: "flex", flexWrap: "wrap" }}
				></div>
			</Grid2>
		</div>
	);
}

export default ImageServiceTesting;
